export const decodeToken = () => {
  try {
    const token = sessionStorage.getItem('token');
    if (!token) return null;

    // JWT format: header.payload.signature
    const payload = token.split('.')[1];

    // base64 decode
    const decoded = JSON.parse(atob(payload));

    return decoded;
  } catch (error) {
    console.error('Token decode error:', error);
    return null;
  }
};

export const getAuthUser = () => {
  const decoded = decodeToken();

  if (!decoded) return {};

  return {
    id: decoded.id,
    username: decoded.username,
    role: decoded.role,
    company_id: decoded.company_id,
    company_type: decoded.company_type,
    is_owner: decoded.is_owner
  };
};
